import { HintComponent } from '@accredible-frontend-v2/components/ui-common';
import { AccredibleIconComponentModule } from '@accredible-frontend-v2/new-components/icon';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  standalone: true,
  imports: [CommonModule, HintComponent, TranslocoModule, AccredibleIconComponentModule],
  selector: 'rp-migration-banner',
  templateUrl: './migration-banner.component.html',
  styleUrls: ['./migration-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MigrationBannerComponent {
  onWalletPage = input<boolean>(true);
}
